<template>
  <div id="app">
    <div class="content-header">
      <h1>App错误日志</h1>
    </div>

    <div class="app-container">
      <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
        <el-table-column type="index" align="center" label="id"></el-table-column>
        <el-table-column prop="data" label="数据" align="center">
          <template slot-scope="scope">
            <el-link type="primary" @click="showData(scope.row)"> 点击查看 </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="上报时间"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" @click="editData(scope.row)">编辑</el-button> -->
            <el-button size="mini" type="danger" @click="deleteData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页组件-->
      <div class="pagination-container">
        <el-pagination class="pagiantion" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-size="pagination.pageSize" layout="total, prev, pager, next, jumper" :total="pagination.total"> </el-pagination>
      </div>
    </div>

    <el-drawer title="报错日志" :visible.sync="dialogVisible" size="42%">
      <div class="x-x-scroll-bar" style="white-space: pre-wrap;text-align: left;padding: 16px;">
        {{ dataContent }}
      </div>
      <div class="drawer-bottom" style="display: flex; justify-content: end">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="copyData">复制</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from "@/axios";
import { Loading } from "element-ui";

export default {
  name: "AppErrlogInfo",
  data: function () {
    return {
      dataList: [], //当前页要展示的列表数据
      dialogVisible: false,
      dataContent: "",
      pagination: {
        //分页相关模型数据
        currentPage: 1, //当前页码
        pageSize: 10, //每页显示的记录数
        total: 0, //总记录数
        username: "",
        phone: "",
      },
    };
  },

  //钩子函数，VUE对象初始化完成后自动执行
  mounted() {
    //调用查询全部数据的操作
    this.getuserlist();
  },

  methods: {
    //切换页码
    handleCurrentChange(currentPage) {
      //修改页码值为当前选中的页码值
      this.pagination.currentPage = currentPage;
      //执行查询
      this.getuserlist();
    },
    getuserlist() {
      axios
        .get("/sys/app_errolog/info", {
          params: {
            page: this.pagination.currentPage,
            limit: this.pagination.pageSize,
          },
        })
        .then((res) => {
          this.pagination.pageSize = res.data.data.pageSize;
          this.pagination.currentPage = res.data.data.currPage;
          this.pagination.total = res.data.data.totalCount;
          this.dataList = res.data.data.list;
        });
    },
    deleteData(row) {
      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios.post("/sys/app_errolog/delete/" + row.id).then((res) => {
            this.$message.success(res.data.msg);
            if (res.data.code == "0000") {
              // 删除成功，重新刷新
              this.pagination.currentPage = 1
              this.pagination.pageSize = 10
              this.getuserlist();
            }
          });
        })
        .catch(() => {});
    },
    showData(data) {
      const loading = Loading.service({
        fullscreen: true,
        text: "数据加载中...",
      });
      axios
        .get("/sys/app_errolog/get/" + data.id)
        .then((res) => {
          this.dataContent = res.data.data.data;
          this.dialogVisible = true;
        })
        .finally(() => {
          loading.close();
        });
    },
    copyData() {
      navigator.clipboard.writeText(this.dataContent).then(
        () => {
          this.$message({
            type: "success",
            message: "复制成功!",
          });
        },
        () => {
          this.$message({
            type: "success",
            message: "复制失败，请尝试更新浏览器版本!",
          });
        }
      );
    },
  },
};
</script>

<style scoped>
.x-x-scroll-bar {
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.x-x-scroll-bar::-webkit-scrollbar {
  width: 10px;
}

.x-x-scroll-bar::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.x-x-scroll-bar::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;
  border: 3px solid #f1f1f1;
}

.x-x-scroll-bar::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.drawer-bottom {
  width: 100%;
  position: absolute;
  background: #fff;
  bottom: 0px;
  padding: 6px 24px;
}
</style>
